import flora1 from '../../../media/fasad/Freya.webp'
import flora2 from '../../../media/fasad/Freya.webp'

const floraimages =[
flora1,flora2
]

export default floraimages;